// Minimal toast emitter for app-wide toasts.
// Consumers can listen for the "yubu-toast" CustomEvent on window.
export function showToast(type, message) {
  try {
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
      window.dispatchEvent(new CustomEvent('yubu-toast', { detail: { type, message } }));
      return;
    }
  } catch {
    // fall through to console
  }
  // Fallback: log to console
  if (type === 'error') console.error('Toast:', message);
  else console.log('Toast:', message);
}

export default { showToast };
